module.exports = __webpack_public_path__ + "static/media/title.76838db4.png";